module.exports = __webpack_public_path__ + "static/media/Picverse-image-3.3a975844.jpg";